import { temporarilyNotSupport } from '../../utils'

// 相机
export const createCameraContext = /* @__PURE__ */ temporarilyNotSupport('createCameraContext')
